import { FC, useState } from 'react'
import checkDoubleLineIcon from 'src/assets/svg/check-double-line.svg'
import checkLineIcon from 'src/assets/svg/check-line.svg'
import searchIconGray from 'src/assets/svg/searchIconGray.svg'
import classes from './locationDropdown.module.scss'

const COUNTRIES = [
  'All',
  'Afghanistan',
  'Aland Islands',
  'Albania',
  'Algeria',
  'Andorra',
  'Angola',
  'Argentina',
  'Armenia',
  'Australia',
  'Austria',
  'Azerbaijan',
  'Bahrain',
  'Bangladesh',
  'Belarus',
  'Belgium',
  'Bolivia',
  'Brazil',
  'Bulgaria',
  'Canada',
  'Chile',
  'China',
  'Colombia',
  'Croatia',
  'Czech Republic',
  'Denmark',
  'Egypt',
  'Estonia',
  'Finland',
  'France',
  'Georgia',
  'Germany',
  'Ghana',
  'Greece',
  'Hungary',
  'India',
  'Indonesia',
  'Iran',
  'Iraq',
  'Ireland',
  'Israel',
  'Italy',
  'Japan',
  'Jordan',
  'Kazakhstan',
  'Kenya',
  'Latvia',
  'Lebanon',
  'Lithuania',
  'Luxembourg',
  'Malaysia',
  'Mexico',
  'Morocco',
  'Netherlands',
  'New Zealand',
  'Nigeria',
  'Norway',
  'Pakistan',
  'Peru',
  'Philippines',
  'Poland',
  'Portugal',
  'Romania',
  'Russia',
  'Saudi Arabia',
  'Serbia',
  'Singapore',
  'Slovakia',
  'Slovenia',
  'South Africa',
  'South Korea',
  'Spain',
  'Sweden',
  'Switzerland',
  'Taiwan',
  'Thailand',
  'Turkey',
  'Ukraine',
  'United Arab Emirates',
  'United Kingdom',
  'United States',
  'Uzbekistan',
  'Venezuela',
  'Vietnam',
]

interface LocationDropdownProps {
  onClose: () => void
  onSelect: (country: string) => void
  selected: string | null
}

export const LocationDropdown: FC<LocationDropdownProps> = ({
  onClose,
  onSelect,
  selected,
}) => {
  const [search, setSearch] = useState('')

  const isAllSelected = selected === 'All'

  const isCountrySelected = (country: string) => {
    if (country === 'All') return isAllSelected
    return isAllSelected || selected === country
  }

  const handleSelect = (country: string) => {
    if (country === 'All') {
      onSelect(isAllSelected ? '' : 'All')
    } else {
      onSelect(selected === country ? '' : country)
    }
  }

  const filtered = COUNTRIES.filter((c) =>
    c.toLowerCase().includes(search.toLowerCase())
  )

  return (
    <div className={classes.dropdown}>
      <div className={classes.header}>
        <span className={classes.title}>Select country</span>
        <button className={classes.closeBtn} onClick={onClose} type="button">
          <svg
            fill="none"
            height="16"
            viewBox="0 0 16 16"
            width="16"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M12 4L4 12M4 4L12 12"
              stroke="#25262D"
              strokeLinecap="round"
              strokeWidth="1.5"
            />
          </svg>
        </button>
      </div>
      <div className={classes.innerContent}>
        <div className={classes.searchBox}>
          <input
            className={classes.searchInput}
            onChange={(e) => setSearch(e.target.value)}
            placeholder="Search for country"
            type="text"
            value={search}
          />
          <img
            alt="search"
            className={classes.searchIcon}
            src={searchIconGray}
          />
        </div>
        <div className={classes.currentLocation}>
          <div className={classes.currentLocationRow}>
            <svg
              fill="none"
              height="16"
              viewBox="0 0 16 16"
              width="16"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M14 2L9.33 13.33L7.33 8.67L2.67 6.67L14 2Z"
                fill="#25262D"
              />
            </svg>
            <span className={classes.currentLocationText}>
              Current location
            </span>
          </div>
          <div className={classes.currentLocationSelected}>
            <div className={classes.currentLocationBadge}>
              <img
                alt="selected"
                className={classes.currentLocationBadgeIcon}
                src={checkDoubleLineIcon}
              />
            </div>
            <span className={classes.currentLocationSelectedText}>Georgia</span>
          </div>
        </div>
        <div className={classes.listOfCountries}>
          {filtered.map((country) => (
            <div
              className={classes.countryItem}
              key={country}
              onClick={() => handleSelect(country)}
            >
              <div
                className={`${classes.radio} ${isCountrySelected(country) ? classes.radioSelected : ''}`}
              >
                {isCountrySelected(country) && (
                  <img
                    alt="check"
                    className={classes.radioCheck}
                    src={checkLineIcon}
                  />
                )}
              </div>
              <span className={classes.countryName}>{country}</span>
            </div>
          ))}
        </div>
      </div>
    </div>
  )
}
